import { render } from "./SkeletonSelectCustomer.vue?vue&type=template&id=e0c3029e&scoped=true"
import script from "./SkeletonSelectCustomer.vue?vue&type=script&lang=js"
export * from "./SkeletonSelectCustomer.vue?vue&type=script&lang=js"

import "./SkeletonSelectCustomer.vue?vue&type=style&index=0&id=e0c3029e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c3029e"]])

export default __exports__